export const environment = {
  production: true,
  envName: 'prod',
  addressAuthKey:'GaQAjmKPApxUzGG1S7jDR869hlsHXmH7',
  addressUrl:'https://api.psma.com.au/predictive/address',
  sanitizeMap: {
    '\'': '__APS__',
    '#': '__HASH__',
    '-': '__DASH__'
  },

    // feeCodesASSP: 'ASSPS',
  // feeCodesSEWD: 'SEWDS',
  // feeCodePA: 'PAS',
  // feeCodePA_C: 'PA-CS',
  // feeCodePF : 'PFC',
  // feeCodeAPPF0 : 'APPFOFC',
  // feeCodeAPPF10_ : 'APPFO10+',
  // feeCodePFI: 'PFIC',
  // feeCodeEAS: 'EASCC',
  // // feeCodeCF202: 'CF20-2',
  // feeCodeCF202: 'CF20S',
  // feeCodeRMDP: 'RMDPS',
  // feeCodePAC : 'OPPCA',
  // feeCodeHPF: 'HPFS',
  // feeCodeOPP_2: 'OPP-2NW',

  // cww fees
  feeCodesASSP: 'C-APSDDO',
  feeCodesSEWD: 'SDP',
  feeCodePA: 'PAS',
  feeCodePA_C: 'PA-S',
  feeCodePF : 'C-PFIS',
  feeCodeAPPF0 : 'APPF1',
  feeCodeAPPF10_ : 'APPFF10+',
  feeCodePFI: 'PFIU',
  feeCodeEAS: 'C-BOEAPP',
  feeCodeCF202: 'MC20S',
  feeCodeRMDP: 'RMD20',
  feeCodePAC : 'APPF',
  feeCodePAC_NF : 'CNFSC',
  feeCodePAC_F : 'CFSC',
  feeCodeHPF: 'HYPFS',
  feeCodeOPP_2: 'APPFNW',

  // feeCodesASSP_WW: 'ASSPS',
  // feeCodesSEWD_WW: 'SEWDS',
  // feeCodePA_WW: 'W-PSPFS',
  // feeCodePA_C_WW: 'PA-CS',
  // feeCodePF_WW: 'PFC',
  // feeCodeAPPF0_WW: 'APPFOFC',
  // feeCodeAPPF10__WW: 'APPFO10+',
  // feeCodePFI_WW: 'PFIC',
  // feeCodeEAS_WW: 'EASCC',
  // feeCodeCF202_WW: 'CF20S',
  // feeCodeRMDP_WW: 'RMDPS',
  // feeCodePAC_WW: 'OPPCA',
  // feeCodeHPF_WW: 'HPFS',
  // feeCodeOPP_2_WW: 'OPP-2NW',

  // ww fees
  feeCodesASSP_WW: 'W-APSDDO',
  feeCodesSEWD_WW: 'W-APSDDO',
  //feeCodePA_WW: 'WW-PAS',
  feeCodePA_WW: 'CFSR10S',
  feeCodePA_C_WW: 'WW-PA-S',
  feeCodePF_WW: 'W-PFIS',
  feeCodeAPPF0_WW: 'APPWW1',
  feeCodeAPPF10__WW: 'APPWW10+',
  feeCodePFI_WW: 'W-PFIS',
  feeCodeEAS_WW: 'W-BOEAPP',
  feeCodeCF202_WW: 'WMS20',
  feeCodeRMDP_WW: 'W-RMD20',
  feeCodePAC_WW: 'WW-APPF',
  feeCodePAC_WW_NF : 'CNFSW',
  feeCodePAC_WW_F : 'CFSW',
  feeCodeHPF_WW: 'WCPERMIT',
  feeCodeOPP_2_WW: 'W-ADMFNW',

  calendlyUrl: 'https://calendly.com/greater-western-water/recycled-water-inspection',
  cwwInstallationNumber: '125239538', // Footscray office installation number for HYD application

  termsOfUseURL: {
    WW: 'https://www.gww.com.au/building-development/service-booking-terms-conditions',
    CWW: 'https://gww.com.au/terms-use'
  }
};



// WEBPACK FOOTER //
// ./src/app-environments/environment.ts